import React from 'react';
import { inject } from 'mobx-react';
import { FaCheck } from 'react-icons/fa';

import { Flex, Heading, Tag } from 'core/components';

import SidebarItem from '../SidebarItem';
import { greekDisplay } from '../cloudUtil';
import RouteTable from './components/RouteTable';

const OciRouteTablePopover = ({ width, popoutTitle, $hybridMap, ...rest }) => {
  const { nodeData } = rest;
  const { ociCloudMapCollection } = $hybridMap;

  const routeTables =
    nodeData?.route_tables ??
    nodeData?.drgRouteTables ??
    (nodeData?.routeTableId ? [{ id: nodeData.routeTableId }] : null) ??
    [];

  // create array of route table objects
  const uniqueRouteTableIds = [...new Set(routeTables.map(({ id }) => id))];

  if (uniqueRouteTableIds.length === 0) {
    return null;
  }

  const grouppedRouteRules = uniqueRouteTableIds
    .map((id) => {
      const routeTable = ociCloudMapCollection.findEntityById(id);
      if (!routeTable) {
        return [];
      }

      const { routeRules = [], displayName } = routeTable;

      return routeRules.map((rule) => ({ ...rule, routeTable: displayName }));
    })
    .flat();

  const blackHoleRules = grouppedRouteRules.filter((rule) => !!rule.isBlackhole);
  const totalActiveRoutes = grouppedRouteRules.length - blackHoleRules.length;

  return (
    <SidebarItem
      excludeFormProps
      title={
        <Flex alignItems="center" gap={1} width="100%">
          <Heading level={5} mb={0}>
            Route Table
          </Heading>
          <Tag
            intent="primary"
            icon={FaCheck}
            title={`${routeTables.length} active route tables`}
            minimal
            round
            flexGrow={1}
          >
            {greekDisplay(routeTables.length)}
          </Tag>
          <Tag mx={1} intent="success" icon={FaCheck} title={`${totalActiveRoutes} active routes`} minimal round>
            {greekDisplay(totalActiveRoutes)}
          </Tag>

          {blackHoleRules.length > 0 && (
            <Tag mr={1} intent="danger" icon="error" title={`${blackHoleRules.length} blackhole routes`} minimal round>
              {greekDisplay(blackHoleRules.length)}
            </Tag>
          )}
        </Flex>
      }
      popoutTitle={popoutTitle}
      icon="route"
      dialogProps={{ width: `${width}px` }}
    >
      <RouteTable key={nodeData.id} routeTableRules={grouppedRouteRules} />
    </SidebarItem>
  );
};

export default inject('$hybridMap')(OciRouteTablePopover);
